import React from 'react';
import Loader from 'shared/ui/loader/Loader';

export default class MatchesLoader extends React.Component {

    render() {
        return <Loader className="medium-loader matches" />;
    }
}
